<div class="panel">
    <h3>Parcelas</h3>
    <p *ngIf="proposta.taxaCliente.parcelaMax > 0">Máximo: {{proposta.taxaCliente.parcelaMax || 0 | currency:'BRL':'symbol':'1.2-2'}}</p>
    <div class="row quotas">
        <div *ngFor="let parcela of parcelasSimuladas" class="col-ths col-xs-5ths">
            <input type="radio" name="radioParcelas" [id]="parcela.quantidade" [value]="parcela.quantidade" (change)="onSelectParcela(parcela)" [checked]="parcela.quantidade == simulacao.parcelas" [disabled]="!parcela.exibir">
            <label [for]="parcela.quantidade"><span *ngIf="parcela.exibir">{{parcela.quantidade}}x<br>{{parcela.valor | currency:'BRL':'symbol':'1.2-2'}}</span></label>
        </div>
    </div>
</div>

<div class="panel">
    <h3>Primeira Parcela</h3>
    <p class="border">{{simulacao.primeiraParcela * 1000 | date: 'dd/MM/yyyy'}}</p>
    <calendar [titleButton]="'alterar'" [titleCalendar]="'Data para pagamento'" [startDate]="proposta.taxaCliente.dataCarenciaMin" [endDate]="proposta.taxaCliente.dataCarenciaMax" [dateSelected]="simulacao.primeiraParcela" (dateSelectedChange)="onChangePrimeiraParcela($event)"></calendar>
</div>
